import { opacityModifier } from '@/utils';
import styled from 'styled-components';
import { LinkProps } from './link.types';

function getColor(look: LinkProps['look'], isDisabled?: boolean, isBlocked?: boolean) {
  if (isDisabled) return 'ui4';
  if (isBlocked) return 'ui2';

  switch (look) {
    case 'positive':
      return 's1';
    case 'negative':
      return 'ac11';
    default:
      return 's1';
  }
}

export const Container = styled.div<{
  $isDisabled?: boolean;
  $isBlocked?: boolean;
  $look: LinkProps['look'];
}>`
  height: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: 75ms all;
  pointer-events: ${({ $isDisabled }) => ($isDisabled ? 'none' : 'auto')};
  fill: ${({ theme: { color }, $isDisabled, $isBlocked, $look }) =>
    color[getColor($look, $isDisabled, $isBlocked)]};
  color: ${({ theme: { color }, $isDisabled, $isBlocked, $look }) =>
    color[getColor($look, $isDisabled, $isBlocked)]};

  &:hover {
    color: ${({ theme: { color }, $isDisabled, $isBlocked, $look }) =>
      color[getColor($look, $isDisabled, $isBlocked)]};
    text-shadow: ${({ theme: { color }, $isDisabled, $isBlocked, $look }) =>
      opacityModifier(color[getColor($look, $isDisabled, $isBlocked)], 0.2)}
      0px 0px 5px;
    fill: ${({ theme: { color }, $isDisabled, $isBlocked, $look }) =>
      color[getColor($look, $isDisabled, $isBlocked)]};
    ${({ theme: { color }, $isDisabled, $isBlocked, $look }) =>
      `filter: drop-shadow(0px 0px 5px ${
        !$isDisabled && !$isBlocked ? color[getColor($look)] : 'transparent'
      })`}
`;

export const Link = styled.span`
  user-select: none;
  ${({ theme: { font } }) => font.t3};
`;

export const IconContainer = styled.div`
  fill: inherit;
  transition: 75ms all;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
`;
